class NewLetterForm extends HTMLElement {
  constructor() {
    super();
    this.debounceHandleSubmit = this.debounce(
      this.submitHandler.bind(this),
      200
    );
  }

  connectedCallback() {
    this.init();
    this.listId = "Svh2PP";
    this.companyId = "Ws5zkw";
  }

  init() {
    this.domElements();
    this.bindListeners();
  }

  domElements() {
    this.form = this.querySelector("form");
    this.successMessage = this.querySelector(
      ".newsletter-form__message--success"
    );
    this.errorMessage = this.querySelector(".newsletter-form__message--error");
    this.submitBtn = this.querySelector(".newsletter-form__button--submit");
    this.greenTick = this.querySelector(".greenTick");

    // form elements
    this.formFieldWrapper = this.querySelector(
      ".newsletter-form__field-wrapper"
    );
    this.formDescription = this.querySelector(".email-description");
  }

  bindListeners() {
    this.submitHandler = (e) => {
      e.preventDefault();
      this.debounceHandleSubmit(e);
    };

    this.form.addEventListener("submit", this.submitHandler);
  }

  debounce(fn, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), delay);
    };
  }
  // newsletter-form__button--submit-loading
  handleShowSuccessMessage() {
    this.handleHideFormElements();

    this.handleHideErrorMessage();

    this.form.reset();

    if (!this.successMessage) return;

    this.successMessage.classList.remove(
      "newsletter-form__message--success-hidden"
    );

    if (this.successMessageTimer) clearTimeout(this.successMessageTimer);

    this.successMessageTimer = setTimeout(() => {
      this.handleHideSuccessMessage();
      clearTimeout(this.successMessageTimer);
    }, 5000);
  }

  handleHideSuccessMessage() {
    this.handleShowFormElements();

    if (!this.successMessage) return;

    this.successMessage.classList.add(
      "newsletter-form__message--success-hidden"
    );
  
    if (greenTick) {
      greenTick.style.display = "none";
    }
  }

  handleShowErrorMessage() {
    if (!this.errorMessage) return;

    this.handleHideSuccessMessage();

    this.errorMessage.classList.remove(
      "newsletter-form__message--error-hidden"
    );
  }

  handleHideErrorMessage() {
    if (!this.errorMessage) return;

    this.errorMessage.classList.add("newsletter-form__message--error-hidden");
  }

  handleHideFormElements() {
    if (!this.formFieldWrapper || !this.formDescription) return;

    this.formFieldWrapper.classList.add(
      "newsletter-form__field-wrapper--hidden"
    );
    this.formDescription.classList.add("email-description--hidden");
  }

  handleShowFormElements() {
    if (!this.formFieldWrapper || !this.formDescription || !this.form) return;

    this.formFieldWrapper.classList.remove(
      "newsletter-form__field-wrapper--hidden"
    );
    this.formDescription.classList.remove("email-description--hidden");
  }

  handleShowLoader() {
    this.submitBtn.classList.add("newsletter-form__button--submit-loading");
  }

  handleHideLoader() {
    this.submitBtn.classList.remove("newsletter-form__button--submit-loading");
  }

  async submitHandler(e) {
    try {
      this.handleShowLoader();
      const formData = new FormData(e.target);
      const emailInput = formData.get("contact[email]");
      if (!emailInput) return;
      await this.handleSubscribe(emailInput);
      this.handleShowSuccessMessage();
    } catch (error) {
      this.handleShowErrorMessage();
      console.error(error);
    } finally {
      this.handleHideLoader();
    }
  }

  async handleSubscribe(emailInput) {
    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyId}&onsite=true`,
        {
          method: "POST",
          headers: {
            accept: "application/vnd.api+json",
            revision: "2025-07-15",
            "content-type": "application/vnd.api+json",
          },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: emailInput,
                      subscriptions: {
                        email: {
                          marketing: {
                            consent: "SUBSCRIBED",
                          },
                        },
                      },
                    },
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    type: "list",
                    id: this.listId,
                  },
                },
              },
            },
          }),
        }
      );
      if (!response.ok) throw new Error("Something went wrong.");
    } catch (error) {
      throw error;
    }
  }

  disconnectedCallback() {
    this.form.removeEventListener("submit", this.submitHandler);
  }
}

customElements.define("newsletter-form", NewLetterForm);
